export default {
  SET_COMPANIES: 'SET_COMPANIES',
  SET_HEALTH_REGIONS: 'SET_HEALTH_REGIONS',
  SET_MENU_ITEM_ID: 'SET_MENU_ITEM_ID',
  SET_MENU: 'SET_MENU',
  SET_PERMISSIONS: 'SET_PERMISSIONS',
  SET_USER: 'SET_USER',
  SET_PROFILE: 'SET_PROFILE',
  SET_USER_HAS_VALID_ROLE: 'SET_USER_HAS_VALID_ROLE',
  SET_SCHOOLS: 'SET_SCHOOL',
  SET_USER_LOGOUT: 'SET_USER_LOGOUT',
  SET_SERVICE_CENTERS: 'SET_SERVICE_CENTERS',
  SET_USER_GOALS_AND_OBJECTIVES_FLAG: 'SET_USER_GOALS_AND_OBJECTIVES_FLAG'
};
